import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, Card, Dialog, DialogActions, DialogTitle, FormControl, FormControlLabel, FormHelperText, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AntSwitch from "../../../components/AntSwitch";
import { END_POINTS } from "../../../shared/endpoints";
import axiosInstance from "../../../axios/axios";
import { toast } from "react-toastify";
import { useEncryptService } from "../../../shared/hooks";
import "./../../../styles.scss";
import SkeletonLoader from "../../../modules/dashboard/shared/skeleton_loader";

// Helper function to trim all string values in an object before sending payload
const trimPayload = (obj: any): any => {
    if (obj === null || obj === undefined) return obj;
    if (typeof obj === 'string') return obj.trim();
    if (Array.isArray(obj)) return obj.map(trimPayload);
    if (typeof obj === 'object') {
        const trimmed: any = {};
        for (const key in obj) {
            trimmed[key] = trimPayload(obj[key]);
        }
        return trimmed;
    }
    return obj;
};

const AddCredentional = ({ credType, callFetchUsers }: any) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showPrivacyPassword, setshowPrivacyPassword] = useState(false);
    const [sshVisible, setSshVisible] = useState(true);
    // const [globalCred, setGlobalCred] = useState(false);
    const [description, setDescription] = useState<string>(""); // Initialize as empty
    const [credentialName, setCredentialName] = useState<string>(""); // Initialize as empty
    const [username, setUsername] = useState<string>("");
    const [auth_protocol, setAuthProtocol] = useState<string>("");
    const [priv_protocol, setPrivProtocol] = useState<string>("");
    const [auth_password, setAuthPassword] = useState<string>("");
    const [exec_password, setExecPassword] = useState<string>("");
    const [priv_password, setPrivPassword] = useState<string>("");// Initialize as empty
    const [user, setUser] = useState<string>(""); // Initialize as empty
    const [accountId, setAccountId] = useState<string>("");
    const [apiToken, setApiToken] = useState<string>(""); // Initialize as empty
    const [password, setPassword] = useState<string>(""); // Initialize as empty
    const [execPasswordEnabled, setExecPasswordEnabled] = useState(false);
    const [passwordType, setPasswordType] = useState<string>("password"); // Default to "password"
    const [roleDetails, setRoleDetails] = useState<any>([]);
    const [selectedType, setSelectedType] = useState<string>("ssh");
    const [credential_type_id, setCredentialTypeId] = useState<string | null>(null); // Default to SSH
    const { doEncryptLogin } = useEncryptService();
    const [credentialTypes, setCredentialTypes] = useState<any>([]);
    const [isLoadingCredentialTypes, setIsLoadingCredentialTypes] = useState<boolean>(true);

    // Cancel confirmation dialog state
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const [ppkFile, setPpkFile] = useState<File | null>(null);
    const [pemFile, setPemFile] = useState<File | null>(null);
    const [ppkFileName, setPpkFileName] = useState<string>("");
    const [pemFileName, setPemFileName] = useState<string>("");
    const [privateKeyFileName, setPrivateKeyFileName] = useState("");
    const ppkFileInputRef = useRef<HTMLInputElement>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Validation State
    const [touched, setTouched] = useState<any>({});

    const handleBlur = (field: string) => {
        setTouched({ ...touched, [field]: true });
    };

    // Validation Functions
    const getError = (field: string, value: string) => {
        if (!touched[field]) return "";

        switch (field) {
            case "credentialName":
                if (!value || value.trim().length < 3) return "Credential Name is required";
                break;
            case "username":
                if (!value || value.trim() === "") return selectedType === "aws" ? "Access Key is required" : "User Name is required";
                break;
            case "password":
                if (!value || value.trim() === "") return selectedType === "aws" ? "Secret Key is required" : "Password is required";
                break;
            case "accountId":
                if (!value || value.trim() === "") return "Account ID is required";
                break;
            case "apiToken":
                if (!value || value.trim() === "") return "API Token is required";
                break;
            case "exec_password":
                if (execPasswordEnabled && (!value || value.trim() === "")) return "Exec Password is required";
                break;
            case "auth_protocol":
                if (!value || value.trim() === "") return "Authentication Protocol is required";
                break;
            case "auth_password":
                if (!value || value.trim() === "") return "Authentication Password is required";
                break;
            case "priv_protocol":
                if (!value || value.trim() === "") return "Privacy Protocol is required";
                break;
            case "priv_password":
                if (!value || value.trim() === "") return "Privacy Password is required";
                break;
            default:
                return "";
        }
        return "";
    };

    useEffect(() => {
        fetchRoles();
        fetchCredentialTypes();
        // Clear form on mount to prevent stale data
        setCredentialName("");
        setDescription("");
        setUsername("");
        setAccountId("");
        setPassword("");
        setApiToken("");
        setAuthProtocol("");
        setAuthPassword("");
        setPrivProtocol("");
        setPrivPassword("");
        setExecPassword("");
        setExecPasswordEnabled(false);
        setTouched({});
    }, []);

    useEffect(() => {
        const selectedCredential = credentialTypes.find((item: any) => item.code === selectedType);
        if (selectedCredential && selectedCredential.password_type.length > 0) {
            setPasswordType(selectedCredential.password_type[0].code);
            setCredentialTypeId(selectedCredential.password_type[0].id) // Set first option as default
            //handlePasswordInputChange(selectedCredential.password_type[0].code); // Optional
        } else {
            setPasswordType(""); // Reset if none
        }
    }, [selectedType]);


    const fetchRoles = async () => {
        const url = `${END_POINTS.ORG_ROLES}`;
        const payload = {
            order_column: "name",
            sort_by: "ASC"
        }
        try {
            const response = await axiosInstance.post(url, payload);
            if (response.status === 200) {
                setRoleDetails(response.data?.data);
            }
        } catch (error: any) {
            console.error("Error fetching credential details:", error.response);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
        }
    };

    const fetchCredentialTypes = async () => {
        try {
            setIsLoadingCredentialTypes(true);
            const response = await axiosInstance.get(END_POINTS.CREDENTIAL_TYPES);
            if (response.status === 200) {
                //setCredentialRoles(response?.data?.data) ;
                //console.log("Parsed Data:", setCredentialRoles); 
                if (response?.data?.data.length > 0) {
                    var hardcodedData = response?.data?.data;
                }
                // const hardcodedData = [
                //     {
                //         id: "ffb7c8cb-dcdc-40a5-824e-ebcb279d3c5e",
                //         code: "ssh",
                //         name: "SSH",
                //         password_type: [
                //             {
                //                 id: "ed853316-c67e-4524-a684-ecf12732d306",
                //                 code: "password",
                //                 name: "Password"
                //             },
                //             {
                //                 id: "af7cd431-6ea4-44d4-8b26-2db034e4fb91",
                //                 code: "private_key",
                //                 name: "Private Key"
                //             },
                //             {
                //                 id: "df6b0409-a256-43bd-81c2-a2335c5bb4e5",
                //                 code: "none",
                //                 name: "None"
                //             }
                //         ]
                //     },
                //     {
                //         id: "43ee1126-0590-444a-a2c8-fcdd61fce2bd",
                //         code: "api",
                //         name: "API",
                //         password_type: [
                //             {
                //                 id: "f26b4891-b208-41be-a486-b8b3be9a81cd",
                //                 code: "api_token",
                //                 name: "API Token"
                //             }
                //         ]
                //     },
                //     {
                //         id: "ed75bf37-ce7b-43cf-8f79-2cbd2e098b24",
                //         code: "windows",
                //         name: "WINDOWS",
                //         password_type: [
                //             {
                //                 id: "b1c8e3f4-a5e9-4c6b-9f7d-2b1c8e3f4a5b",
                //                 code: "password",
                //                 name: "Password"
                //             }
                //         ]
                //     },
                //     {
                //         id: "6aca587c-1b5a-40f6-a9a4-b60165adb3a6",
                //         code: "snmp",
                //         name: "SNMP",
                //         password_type: [
                //             {
                //                 id: "c8e3f4a5-e9b1-4c6b-9f7d-2b1c8e3f4a5b",
                //                 code: "community_string",
                //                 name: "Community string(v1, v2c)"
                //             },
                //             {
                //                 id: "d8e3f4a5-e9b1-4c6b-9f7d-2b1c8e3f4a5b",
                //                 code: "snmp_password_v3",
                //                 name: "Password(v3)"
                //             }
                //         ]
                //     }
                // ];
                //hard code data      
                setCredentialTypes(hardcodedData);
                if (hardcodedData.length > 0) {
                    setSelectedType(hardcodedData[0].code);
                    //setCredentialTypeId(hardcodedData[0].id) // Default to first type

                }

                if (hardcodedData.length > 0) {
                    const selectedCredential = hardcodedData.find((item: any) => item.code === selectedType);
                    if (selectedCredential && selectedCredential.password_type.length > 0) {
                        setCredentialTypeId(selectedCredential.password_type[0].id) // store entire object
                        setPasswordType(selectedCredential.password_type[0].code); // Set first option as default
                        //handlePasswordInputChange(selectedCredential.password_type[0].code); // Optional
                    } else {
                        setPasswordType(""); // Reset if none
                    }
                }
                setIsLoadingCredentialTypes(false);

                // response?.data?.data?.map((obj: any) => {
                //     if (obj.code === "ssh") {
                //         setSSHPasswordTypes(obj?.password_type)
                //     } else if (obj.code === "api") {
                //         setAPIPasswordTypes(obj?.password_type)
                //     }
                // })

            }
        } catch (error: any) {
            console.error("Error fetching agent list:", error.response);
            toast.error(
                error.response?.data?.message || "Something went wrong",
                { type: "error" }
            );
            setIsLoadingCredentialTypes(false);
        }
    };
    // const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setSelectedType(event.target.value); // Update selected type (SSH or API)
    //     if(event.target.value === "snmp"){
    //         setSshVisible(false);
    //         setApiVisible(false);
    //         setSnmpVisible(true);
    //         setPasswordType("password");
    //     }
    // };

    const handleRadioChange = (item: any) => {
        setSelectedType(item.code);
        setTouched({}); // Reset validation state

        // Clear all fields when switching types
        setCredentialName("");
        setDescription("");
        setUsername("");
        setAccountId("");
        setPassword("");
        setApiToken("");
        setAuthProtocol("");
        setAuthPassword("");
        setPrivProtocol("");
        setPrivPassword("");
        setExecPassword("");
        setExecPasswordEnabled(false);
        setShowPassword(false);
        setshowPrivacyPassword(false);
        setPpkFile(null);
        setPpkFileName("");
        setPemFile(null);
        setPemFileName("");
        if (ppkFileInputRef.current) {
            ppkFileInputRef.current.value = '';
        }

        if (item && item.password_type.length > 0) {
            setCredentialTypeId(item.password_type[0].id)
            setPasswordType(item.password_type[0].code);
        } else {
            setPasswordType("");
            setCredentialTypeId("");
        }
    };
    const handleToggleChangeExecPassword = (value: boolean) => {
        setExecPasswordEnabled(value); // Update the state when the switch is toggled
    };

    const handlePasswordInputChange = (value: any) => {
        console.log("Selected Password Type Object:", value);
        setPasswordType(value.code);
        setCredentialTypeId(value.id);
    };

    const handlePpkFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            // Validate file extension
            const fileName = file.name.toLowerCase();
            if (!fileName.endsWith('.pem')) {
                toast.error("Please upload a PEM file (.pem)");
                if (ppkFileInputRef.current) {
                    ppkFileInputRef.current.value = '';
                }
                return;
            }
            setPpkFile(file);
            setPemFile(file);
            setPpkFileName(file.name);
            setPemFileName(file.name);
            setPrivateKeyFileName(file.name);
        }
    };

    const handlePpkUploadClick = () => {
        ppkFileInputRef.current?.click();
    };



    const handleSaveClick = async () => {
        setIsSubmitting(true);
        let payload: any = {
            cred_name: credentialName,
            global_cred: credType,
            user_name: user,
            username: username,
            description: description,
            enable_password: execPasswordEnabled,

        };

        // Handle auto-assign logic
        if (!execPasswordEnabled) {
            payload.auto_assign = true;
            delete payload.enable_password;
        } else {
            payload.auto_assign = false;
        }

        if (passwordType === "private_key") {
            delete payload.auto_assign;
        }

        // Trim all string values in payload before further processing
        payload = trimPayload(payload);

        // Handle exec password logic
        if (execPasswordEnabled) {
            payload = Object.assign(payload, {
                enable_password: doEncryptLogin(exec_password?.trim()), // Encrypt the exec password
            });
            payload.exec_password = true;
        } else {
            payload.exec_password = false;
        }

        // Handle password type logic
        if (passwordType === "password") {
            payload.password = password?.trim(); // Use the password field
            payload = Object.assign(payload, {
                password: doEncryptLogin(payload.password), // Encrypt the password
            });
        }

        if (selectedType === "aws") {
            payload.account_id = doEncryptLogin(accountId?.trim());
            payload.access_key = doEncryptLogin(username?.trim());
            payload.secret_key = doEncryptLogin(password?.trim());
            delete payload.username;
            delete payload.password;
            delete payload.exec_password;
            delete payload.enable_password;
            delete payload.user_name;
            delete payload.auto_assign;
        }

        // Handle API token logic
        if (selectedType === "api") {
            payload.encrypt = true;
            payload.api_token = doEncryptLogin(apiToken?.trim());
            const APIType = credentialTypes.find((type: any) => type.code === selectedType)
                ?.password_type?.find((type: { code: string }) => type.code === "api_token");

            if (APIType) {
                payload.credential_type_id = APIType.id;
            }
        }

        if (credential_type_id !== null && credential_type_id !== "" && passwordType !== "private_key") {
            payload.credential_type_id = credential_type_id;
        }

        if (selectedType === "snmp") {
            if (passwordType == "community_string") {
                payload.community_string = doEncryptLogin(password?.trim());
            } else {
                payload.auth_protocol = doEncryptLogin(auth_protocol?.trim());
                //payload.auth_protocol = auth_protocol;

                payload.auth_password = doEncryptLogin(auth_password?.trim());
                payload.priv_protocol = doEncryptLogin(priv_protocol?.trim());
                //payload.priv_protocol = priv_protocol;
                payload.priv_password = doEncryptLogin(priv_password?.trim());
                delete payload.exec_password;
                delete payload.enable_password;
                delete payload.user_name;
                delete payload.auto_assign;

                //delete payload.password;
                //delete payload.private_key;
            }
        }

        // Encrypt username if it exists
        if ('username' in payload) {
            payload = Object.assign(payload, {
                username: doEncryptLogin(payload.username),
            });
        }
        payload.encrypt = true;

        // Handle private key file upload
        if (passwordType === "private_key") {
            const keyFile = ppkFile || pemFile;
            if (!keyFile) {
                toast.error("Please upload a PPK or PEM file");
                setIsSubmitting(false);
                return;
            }

            const privateKeyType = credentialTypes.find((type: any) => type.code === selectedType)
                ?.password_type?.find((type: { code: string }) => type.code === "private_key");

            if (privateKeyType) {
                payload.credential_type_id = privateKeyType.id;
            }

            const formData = new FormData();

            Object.entries(payload).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }

                if (Array.isArray(value)) {
                    formData.append(key, JSON.stringify(value));
                    return;
                }

                if (typeof value === "boolean") {
                    formData.append(key, value ? "true" : "false");
                    return;
                }

                formData.append(key, value as any);
            });

            formData.append("private_key", keyFile);

            try {
                console.log("Payload FormData:", payload);
                const response = await axiosInstance.post(END_POINTS.CREDENTIAL_MGMT, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.status === 200) {
                    toast.success("Credential updated successfully!");
                    callFetchUsers();
                }
            } catch (error: any) {
                console.error("Error updating credential:", error.response);
                toast.error(
                    error.response?.data?.message || "Failed to update credential",
                    { type: "error" }
                );
            } finally {
                setIsSubmitting(false);
            }

            return;
        }

        // For non-private-key types, proceed with API call
        try {
            console.log("Payload:", payload); // Log the payload for debugging

            const response = await axiosInstance.post(END_POINTS.CREDENTIAL_MGMT, payload);
            if (response.status === 200) {
                toast.success("Credential updated successfully!");
                callFetchUsers();
            }
        } catch (error: any) {
            console.error("Error updating credential:", error.response);
            toast.error(
                error.response?.data?.message || "Failed to update credential",
                { type: "error" }
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setDescription("");
        setCredentialName("");
        setUsername("");
        setAccountId("");
        setAuthProtocol("");
        setPrivProtocol("");
        setAuthPassword("");
        setExecPassword("");
        setPrivPassword("");
        setUser("");
        setApiToken("");
        setPassword("");
        setExecPasswordEnabled(false);
        setPasswordType("password");
        setSelectedType("ssh");
        setCredentialTypeId(null);
        setShowPassword(false);
        setshowPrivacyPassword(false);
        setPpkFile(null);
        setPpkFileName("");
        setPemFile(null);
        setPemFileName("");
        if (ppkFileInputRef.current) {
            ppkFileInputRef.current.value = '';
        }
    };

    // Check if the form has any changes
    const hasFormChanges = () => {
        return (
            credentialName.trim() !== "" ||
            description.trim() !== "" ||
            username.trim() !== "" ||
            password.trim() !== "" ||
            apiToken.trim() !== "" ||
            exec_password.trim() !== "" ||
            auth_password.trim() !== "" ||
            priv_password.trim() !== "" ||
            auth_protocol.trim() !== "" ||
            priv_protocol.trim() !== "" ||
            ppkFile !== null ||
            pemFile !== null
        );
    };

    const handleCancelClick = () => {
        if (hasFormChanges()) {
            setIsCancelDialogOpen(true);
        } else {
            resetForm();
            callFetchUsers();
        }
    };

    const handleCancelDialogClose = () => setIsCancelDialogOpen(false);

    const handleConfirmCancel = () => {
        setIsCancelDialogOpen(false);
        resetForm();
        callFetchUsers();
    };

    // Validate if all required fields are filled (description is optional)
    // Validate if all required fields are filled (description is optional)
    const isFormValid = () => {
        // Credential name is always required and must be at least 3 characters
        if (!credentialName || credentialName.trim().length < 3) {
            return false;
        }

        // SSH type validation
        if (selectedType === "ssh") {
            if (!username || username.trim() === "") return false;

            if (passwordType === "password") {
                if (!password || password.trim() === "") return false;
                // Exec password if enabled
                if (execPasswordEnabled && (!exec_password || exec_password.trim() === "")) return false;
            } else if (passwordType === "private_key") {
                if (!ppkFile && !pemFile && !privateKeyFileName) return false;
                // Exec password validation for private_key type when enabled
                if (execPasswordEnabled && (!exec_password || exec_password.trim() === "")) return false;
            }
        }

        // API type validation
        if (selectedType === "api") {
            if (!apiToken || apiToken.trim() === "") return false;
        }

        // SNMP type validation
        if (selectedType === "snmp") {
            if (passwordType === "snmp_password_v3") {
                if (!username || username.trim() === "") return false;
                if (!auth_protocol || auth_protocol.trim() === "") return false;
                if (!auth_password || auth_password.trim() === "") return false;
                if (!priv_protocol || priv_protocol.trim() === "") return false;
                if (!priv_password || priv_password.trim() === "") return false;
            } else {
                // Community String
                if (!password || password.trim() === "") return false;
            }
        }

        // Windows type validation
        if (selectedType === "windows") {
            if (!username || username.trim() === "") return false;
            if (!password || password.trim() === "") return false;
        }

        // AWS type validation
        if (selectedType === "aws") {
            // if (!accountId || accountId.trim() === "") return false;
            if (!username || username.trim() === "") return false;
            if (!password || password.trim() === "") return false;
        }

        return true;
    };

    console.log("credential_type_id", credential_type_id);
    console.log("passwordType", passwordType);
    //     let payload: any = {
    //         "cred_id": credential.id,
    //         "cred_name": credentialDetails.name,
    //         "global_cred": globalCred,
    //         "username": credentialDetails.username,
    //         "role_id": personName,
    //         "user_id": [],
    //         "description": credentialDetails.description,
    //         "enable_password": credentialDetails.enable_password,
    //       }
    //       if (credentialDetails.auto_assign) {  
    //         payload.auto_assign = true;
    //         delete payload.enable_password;
    //       }
    //       else {
    //         payload.auto_assign = false;
    //       }
    //       if (credentialDetails.exec_password) {
    //         payload = Object.assign(payload, {
    //           enable_password: doEncryptLogin(payload.enable_password)
    //         })
    //         payload.exec_password = true
    //       }
    //       else {
    //         payload.exec_password = false
    //       }
    //       if ( passwordType === "password") {
    //         payload.password = credentialDetails.password;
    //         payload = Object.assign(payload, {
    //           password: doEncryptLogin(payload.password)
    //         })
    //         const passwordType = credentialRoles[0].password_type.find((type: { code: string; }) => type.code === 'password');
    //         if (passwordType) {
    //           payload.credential_type_id = passwordType.id;
    //         }
    //       }
    //       if (passwordType === "privateFile") {
    //         payload.private_key = credentialDetails.privateFile;
    //         const privateKeyType = credentialRoles[0].password_type.find((type: { code: string; }) => type.code === 'private_key');
    //         if (privateKeyType) {
    //           payload.credential_type_id = privateKeyType.id;
    //         }
    //       }
    //       if (apiVisisble) {
    //         payload.encrypt=true
    //         payload.api_token = doEncryptLogin(credentialDetails.api_token);
    //         const APIType = credentialRoles[1].password_type.find((type: { code: string; }) => type.code === 'api_token');
    //         if (APIType) {
    //           payload.credential_type_id = APIType.id;
    //         }
    //       }

    //       payload = Object.assign(payload, {
    //         username: doEncryptLogin(payload.username),
    //       })
    //       payload.encrypt = true;
    //     setIsEditable(false); 
    //     try {
    //         const response = await axiosInstance.put(END_POINTS.CREDENTIAL_MGMT, payload); 
    //         if (response.status === 200) {
    //             toast.success("Credential updated successfully!");
    //             setIsEditable(false);
    //             fetchUserList(); 
    //         }
    //     } catch (error: any) {
    //         console.error("Error updating credential:", error.response);
    //         toast.error(
    //             error.response?.data?.message || "Failed to update credential",
    //             { type: "error" }
    //         );
    //     }
    // };

    return (
        <>
            {isLoadingCredentialTypes ? (
                <Card
                    sx={{
                        width: '100%',
                        height: '100%',
                        fontFamily: 'Manrope',
                        fontWeight: 700,
                        fontSize: "15px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        padding: "0px",
                    }}
                    className="white-box">

                    {/* Header Skeleton */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "11px 20px",
                            borderBottom: "1px solid #E2E2F2",
                        }}
                    >
                        <SkeletonLoader
                            count={1}
                            styles={{ height: 20, width: 200 }}
                        />
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <SkeletonLoader
                                count={1}
                                styles={{ height: 32, width: 86 }}
                            />
                            <SkeletonLoader
                                count={1}
                                styles={{ height: 32, width: 86 }}
                            />
                        </div>
                    </div>

                    {/* Content Skeleton */}
                    <Box sx={{ mt: '4%', p: 2 }}>
                        <div className="scroll" style={{ display: 'flex', gap: '10vh', justifyContent: 'center', overflowY: 'auto', height: 'calc(100vh - 235px)' }}>
                            {/* Form Fields Skeleton */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px',
                                width: '22%',
                                minHeight: '500px',
                            }}>
                                <SkeletonLoader count={1} styles={{ height: 56 }} />
                                <SkeletonLoader count={1} styles={{ height: 56 }} />
                                <SkeletonLoader count={1} styles={{ height: 56 }} />
                                <SkeletonLoader count={1} styles={{ height: 56 }} />
                                <SkeletonLoader count={1} styles={{ height: 56 }} />
                            </div>

                            {/* Credential Type Selection Skeleton */}
                            <div>
                                <SkeletonLoader count={1} styles={{ height: 20, width: 150 }} />
                                <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                                    <SkeletonLoader count={1} styles={{ height: 20, width: 80 }} />
                                    <SkeletonLoader count={1} styles={{ height: 20, width: 80 }} />
                                    <SkeletonLoader count={1} styles={{ height: 20, width: 80 }} />
                                    <SkeletonLoader count={1} styles={{ height: 20, width: 80 }} />
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <SkeletonLoader count={1} styles={{ height: 20, width: 120 }} />
                                    <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                                        <SkeletonLoader count={1} styles={{ height: 20, width: 100 }} />
                                        <SkeletonLoader count={1} styles={{ height: 20, width: 100 }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </Card>
            ) : (
                <Card
                    sx={{
                        width: '100%',
                        height: '100%',
                        fontFamily: 'Manrope',
                        fontWeight: 700,
                        fontSize: "15px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        padding: "0px",
                    }}
                    className="white-box">

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "11px 20px",
                            borderBottom: "1px solid #E2E2F2",
                        }}
                    >
                        <h3
                            style={{
                                margin: "0",
                                fontSize: "15px",
                                fontWeight: "700",
                                lineHeight: "20px",
                            }}
                        >
                            {credType ? "Create Credential" : "Create Credential"}
                        </h3>
                        <div>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={handleCancelClick} // Cancel edit mode
                                sx={{ border: "1px solid blue", width: "86px", marginRight: '12px' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={handleSaveClick} // Save changes and disable edit mode
                                sx={{ border: "1px solid blue", width: "86px" }}
                                disabled={!isFormValid() || isSubmitting} // Disable if required fields are not filled or if submitting
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                    <Box sx={{ mt: '4%', p: 2 }}>
                        <div className="scroll" style={{ display: 'flex', gap: '10vh', justifyContent: 'center', overflowY: 'auto', height: 'calc(100vh - 235px)' }}>
                            {selectedType === "ssh" && (
                                <div style={{
                                    display: 'flex', flexDirection: 'column', gap: '10px', width: '22%',
                                    minHeight: '500px',

                                }}>
                                    <TextField
                                        label="Credential Name"
                                        required
                                        fullWidth
                                        sx={{ mt: 1.5 }}
                                        value={credentialName}
                                        onChange={(e) => setCredentialName(e.target.value)}
                                        onBlur={() => handleBlur("credentialName")}
                                        error={!!getError("credentialName", credentialName)}
                                        helperText={getError("credentialName", credentialName)}
                                        autoComplete="off"
                                    />

                                    <TextField
                                        label="Description"
                                        fullWidth
                                        sx={{ mt: 1 }}
                                        value={description} // Bind to state
                                        onChange={(e) => setDescription(e.target.value)} // Update state on change
                                        autoComplete="off"
                                    />
                                    {sshVisible && (

                                        <TextField
                                            label="User Name"
                                            required
                                            fullWidth
                                            sx={{ mt: 1 }}
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            onBlur={() => handleBlur("username")}
                                            error={!!getError("username", username)}
                                            helperText={getError("username", username)}
                                            autoComplete="off"
                                        />
                                    )}

                                    {sshVisible && (
                                        <>
                                            {passwordType === "password" && (
                                                <>
                                                    <TextField
                                                        label="Password"
                                                        required
                                                        value={password}
                                                        sx={{ mt: 1 }}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        onBlur={() => handleBlur("password")}
                                                        error={!!getError("password", password)}
                                                        helperText={getError("password", password)}
                                                        type={showPassword ? "text" : "password"}
                                                        fullWidth
                                                        autoComplete="new-password"
                                                        slotProps={{
                                                            input: {
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <span className="visibility-icon">
                                                                            {showPassword ? (
                                                                                <Visibility
                                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                                />
                                                                            ) : (
                                                                                <VisibilityOff
                                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                                />
                                                                            )}
                                                                        </span>
                                                                    </InputAdornment>
                                                                ),
                                                            },
                                                        }}
                                                    />

                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        width: '100%'
                                                    }}>
                                                        <p>Exec Password</p>
                                                        <AntSwitch
                                                            onChange={(e) => handleToggleChangeExecPassword(e.target.checked)}
                                                        />
                                                    </div>

                                                    {execPasswordEnabled && (
                                                        <TextField
                                                            label="Exec Password"
                                                            required
                                                            type={showPassword ? "text" : "password"}
                                                            fullWidth
                                                            value={exec_password}
                                                            onChange={(e) => setExecPassword(e.target.value)}
                                                            onBlur={() => handleBlur("exec_password")}
                                                            error={!!getError("exec_password", exec_password)}
                                                            helperText={getError("exec_password", exec_password)}
                                                            autoComplete="new-password"
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <span className="visibility-icon">
                                                                                {showPassword ? (
                                                                                    <Visibility
                                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                                    />
                                                                                ) : (
                                                                                    <VisibilityOff
                                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                                    />
                                                                                )}
                                                                            </span>
                                                                        </InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    {!execPasswordEnabled && (
                                                        <div>
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                <p>Auto Assign</p>
                                                                <AntSwitch
                                                                // Add your existing logic for Auto Assign switch here
                                                                />
                                                            </div>
                                                            <p>This will auto-assign Login Password as Exec Password when missing.</p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {passwordType === "private_key" && (
                                                <>
                                                    <Box
                                                        sx={{
                                                            border: "1px dashed #3a2ada",
                                                            padding: "10px",
                                                            textAlign: "center",
                                                        }}
                                                    >
                                                        <Box sx={{ mb: 1, fontSize: "14px", fontWeight: 500, textAlign: "left" }}>
                                                            Upload PEM File <span style={{ color: "black" }}>*</span>
                                                        </Box>
                                                        <input
                                                            type="file"
                                                            accept=".pem"
                                                            ref={ppkFileInputRef}
                                                            onChange={handlePpkFileChange}
                                                            style={{ display: "none" }}
                                                        />
                                                        <Button
                                                            variant="contained"
                                                            onClick={handlePpkUploadClick}
                                                            sx={{
                                                                backgroundColor: "#3A2AdA",
                                                                color: "white",
                                                                "&:hover": {
                                                                    backgroundColor: "#3225b7",
                                                                },
                                                            }}
                                                        >
                                                            Upload PEM File
                                                        </Button>
                                                        {privateKeyFileName && (
                                                            <Box sx={{ mt: 1, fontSize: "12px", color: "text.secondary" }}>
                                                                Selected: {privateKeyFileName}
                                                            </Box>
                                                        )}
                                                        <Box>
                                                            <p>If a PPK file is available, it should be converted into a PEM file</p>
                                                        </Box>
                                                    </Box>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <p>Exec Password</p>
                                                        <AntSwitch
                                                            checked={execPasswordEnabled}
                                                            onChange={(e) => handleToggleChangeExecPassword(e.target.checked)}
                                                        />
                                                    </div>

                                                    {execPasswordEnabled && (
                                                        <TextField
                                                            label="Exec Password"
                                                            required
                                                            type={showPassword ? "text" : "password"}
                                                            fullWidth
                                                            value={exec_password}
                                                            onChange={(e) => setExecPassword(e.target.value)}
                                                            onBlur={() => handleBlur("exec_password")}
                                                            error={!!getError("exec_password", exec_password)}
                                                            helperText={getError("exec_password", exec_password)}
                                                            autoComplete="new-password"
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <span className="visibility-icon">
                                                                                {showPassword ? (
                                                                                    <Visibility
                                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                                    />
                                                                                ) : (
                                                                                    <VisibilityOff
                                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                                    />
                                                                                )}
                                                                            </span>
                                                                        </InputAdornment>
                                                                    ),
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                    {/* {credType && (
                                <div>
                                    <FormControl sx={{ width: "100%" }}>
                                        <InputLabel id="multiple-checkbox-label">Select Role</InputLabel>
                                        <Select
                                            labelId="multiple-checkbox-label"
                                            id="multiple-checkbox"
                                            multiple
                                            sx={{ mt: 1 }}
                                            value={personName}
                                            onChange={(event) => {
                                                const {
                                                    target: { value },
                                                } = event;
                                                setPersonName(
                                                    typeof value === 'string' ? value.split(',') : value
                                                );
                                            }}
                                            input={<OutlinedInput label="Select Role" />}
                                            renderValue={(selected) => {
                                                // selected is array of ids, map to names
                                                const selectedNames = selected
                                                    .map((id) => {
                                                        const found = roleDetails.find((role: any) => role.id === id);
                                                        return found ? found.name : id;
                                                    });
                                                const maxChips = 3;
                                                const displayedChips = selectedNames.slice(0, maxChips);
                                                const remainingCount = selectedNames.length - maxChips;
                                                return (
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                                                        {displayedChips.map((name, idx) => (
                                                            <Chip
                                                                key={selected[idx]}
                                                                label={name}
                                                                style={{ backgroundColor: isDarkMode ? '#535a6b ' : 'white' }}
                                                            />
                                                        ))}
                                                        {remainingCount > 0 && (
                                                            <Chip
                                                                label={`+${remainingCount} more`}
                                                                style={{ backgroundColor: isDarkMode ? '#535a6b ' : 'white' }}
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            }}
                                            MenuProps={SelectMenuProps}
                                        >
                                            {roleDetails.map((role: any) => (
                                                <MenuItem key={role.id} value={role.id}>
                                                    <Checkbox checked={personName.includes(role.id)} />
                                                    <ListItemText primary={role.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            )} */}
                                </div>
                            )}
                            {selectedType === "api" && (
                                <Box sx={{ width: "22%" }}>
                                    <TextField
                                        label="Credential Name"
                                        required
                                        sx={{ mt: 2 }}
                                        fullWidth
                                        value={credentialName}
                                        onChange={(e) => setCredentialName(e.target.value)}
                                        onBlur={() => handleBlur("credentialName")}
                                        error={!!getError("credentialName", credentialName)}
                                        helperText={getError("credentialName", credentialName)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Description"
                                        fullWidth
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label={passwordType === "password" ? "API Password" : "API Token"}
                                        required
                                        fullWidth
                                        value={apiToken}
                                        onChange={(e) => setApiToken(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        onBlur={() => handleBlur("apiToken")}
                                        error={!!getError("apiToken", apiToken)}
                                        helperText={getError("apiToken", apiToken)}
                                        autoComplete="off"
                                    />
                                    {credType && (
                                        <></>
                                    )}
                                </Box>
                            )}
                            {selectedType === "snmp" && (
                                <div style={{
                                    display: 'flex', flexDirection: 'column', gap: '10px', width: '25%',
                                    minHeight: '500px',

                                }}>
                                    <TextField
                                        label="Credential Name"
                                        required
                                        fullWidth
                                        sx={{ mt: 2 }}
                                        value={credentialName}
                                        onChange={(e) => setCredentialName(e.target.value)}
                                        onBlur={() => handleBlur("credentialName")}
                                        error={!!getError("credentialName", credentialName)}
                                        helperText={getError("credentialName", credentialName)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Description"
                                        fullWidth
                                        value={description} // Bind to state
                                        onChange={(e) => setDescription(e.target.value)} // Update state on change
                                        sx={{ mt: 1.5 }}
                                        autoComplete="off"
                                    />
                                    {passwordType === "snmp_password_v3" && (
                                        <>
                                            <TextField
                                                label="User Name"
                                                required
                                                fullWidth
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                                sx={{ mt: 1 }}
                                                onBlur={() => handleBlur("username")}
                                                error={!!getError("username", username)}
                                                helperText={getError("username", username)}
                                                autoComplete="off"
                                            />
                                        </>
                                    )}

                                    {passwordType !== "snmp_password_v3" && (<>
                                        <TextField
                                            label="Community String"
                                            required
                                            type={showPassword ? "text" : "password"}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            fullWidth
                                            sx={{ mt: 1.5 }}
                                            onBlur={() => handleBlur("password")}
                                            error={!!getError("password", password)}
                                            helperText={getError("password", password)}
                                            autoComplete="new-password"
                                            slotProps={{
                                                input: {
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <span className="visibility-icon">
                                                                {showPassword ? (
                                                                    <Visibility
                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                    />
                                                                ) : (
                                                                    <VisibilityOff
                                                                        onClick={() => setShowPassword(!showPassword)}
                                                                    />
                                                                )}
                                                            </span>
                                                        </InputAdornment>
                                                    ),
                                                },
                                            }}
                                        />
                                    </>)}

                                    {passwordType === "snmp_password_v3" && (
                                        <>
                                            <FormControl fullWidth sx={{ mt: 1 }} error={!!getError("auth_protocol", auth_protocol)}>
                                                <InputLabel
                                                    id="auth-protocol-label"
                                                    required
                                                    sx={{
                                                        fontSize: '12px',
                                                        "& .MuiFormLabel-asterisk": {
                                                            color: "black"
                                                        },
                                                        "&.Mui-error": {
                                                            color: "rgba(0, 0, 0, 0.6)",
                                                            "& .MuiFormLabel-asterisk": {
                                                                color: "#d32f2f"
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Authentication Protocol
                                                </InputLabel>
                                                <Select
                                                    sx={{
                                                        height: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center', // Center text vertically
                                                        fontSize: '14px',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center', // Center content vertically
                                                            paddingTop: '8px',     // Optional: fine-tune vertical spacing
                                                            paddingBottom: '8px',
                                                        },
                                                    }}
                                                    labelId="auth-protocol-label"
                                                    id="auth-protocol-select"
                                                    value={auth_protocol}
                                                    label="Authentication Protocol"
                                                    onChange={(e) => setAuthProtocol(e.target.value)}
                                                    onBlur={() => handleBlur("auth_protocol")}
                                                >
                                                    <MenuItem value="md5">md5</MenuItem>
                                                    <MenuItem value="sha">sha</MenuItem>
                                                    <MenuItem value="sha224">sha224</MenuItem>
                                                    <MenuItem value="sha256">sha256</MenuItem>
                                                    <MenuItem value="sha384">sha384</MenuItem>
                                                    <MenuItem value="sha512">sha512</MenuItem>
                                                    <MenuItem value="none">none</MenuItem>
                                                </Select>
                                                <FormHelperText>{getError("auth_protocol", auth_protocol)}</FormHelperText>
                                            </FormControl>
                                            <TextField
                                                label="Authentication Password"
                                                required
                                                value={auth_password}
                                                sx={{ mt: 1 }}
                                                onChange={(e) => setAuthPassword(e.target.value)}
                                                fullWidth
                                                onBlur={() => handleBlur("auth_password")}
                                                error={!!getError("auth_password", auth_password)}
                                                helperText={getError("auth_password", auth_password)}
                                                autoComplete="new-password"
                                            />

                                            <FormControl fullWidth sx={{ mt: 1 }} error={!!getError("priv_protocol", priv_protocol)}>
                                                <InputLabel
                                                    id="privacy-protocol-label"
                                                    required
                                                    sx={{
                                                        fontSize: '12px',
                                                        "& .MuiFormLabel-asterisk": {
                                                            color: "black"
                                                        },
                                                        "&.Mui-error": {
                                                            color: "rgba(0, 0, 0, 0.6)",
                                                            "& .MuiFormLabel-asterisk": {
                                                                color: "#d32f2f"
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Privacy Protocol
                                                </InputLabel>
                                                <Select
                                                    sx={{
                                                        height: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center', // Center text vertically
                                                        fontSize: '14px',
                                                        '& .MuiSelect-select': {
                                                            display: 'flex',
                                                            alignItems: 'center', // Center content vertically
                                                            paddingTop: '8px',     // Optional: fine-tune vertical spacing
                                                            paddingBottom: '8px',
                                                        },
                                                    }}
                                                    labelId="privacy-protocol-label"
                                                    id="privacy-protocol-select"
                                                    value={priv_protocol}
                                                    label="Privacy Protocol"
                                                    onChange={(e) => setPrivProtocol(e.target.value)}
                                                    onBlur={() => handleBlur("priv_protocol")}
                                                >
                                                    <MenuItem value="des">des</MenuItem>
                                                    <MenuItem value="3des">3des</MenuItem>
                                                    <MenuItem value="aes">aes</MenuItem>
                                                    <MenuItem value="aes128">aes128</MenuItem>
                                                    <MenuItem value="aes192">aes192</MenuItem>
                                                    <MenuItem value="aes256">aes256</MenuItem>
                                                    <MenuItem value="none">none</MenuItem>
                                                </Select>
                                                <FormHelperText>{getError("priv_protocol", priv_protocol)}</FormHelperText>
                                            </FormControl>


                                            {/* <TextField
                                label="Privacy Protocol"
                                type={showPassword ? "text" : "password"}
                                value={priv_protocol}
                                
                                onChange={(e) => setPrivProtocol(e.target.value)}
                                fullWidth
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <span className="visibility-icon">
                                                    {showPassword ? (
                                                        <Visibility
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        />
                                                    ) : (
                                                        <VisibilityOff
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        />
                                                    )}
                                                </span>
                                            </InputAdornment>
                                        ),
                                    },
                                }}
                                /> */}
                                            <TextField
                                                label="Privacy Password"
                                                required
                                                value={priv_password}
                                                sx={{ mt: 1 }}
                                                onChange={(e) => setPrivPassword(e.target.value)}
                                                type={showPrivacyPassword ? "text" : "password"}
                                                fullWidth
                                                onBlur={() => handleBlur("priv_password")}
                                                error={!!getError("priv_password", priv_password)}
                                                helperText={getError("priv_password", priv_password)}
                                                autoComplete="new-password"
                                                slotProps={{
                                                    input: {
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <span className="visibility-icon">
                                                                    {showPrivacyPassword ? (
                                                                        <Visibility
                                                                            onClick={() => setshowPrivacyPassword(!showPrivacyPassword)}
                                                                        />
                                                                    ) : (
                                                                        <VisibilityOff
                                                                            onClick={() => setshowPrivacyPassword(!showPrivacyPassword)}
                                                                        />
                                                                    )}
                                                                </span>
                                                            </InputAdornment>
                                                        ),
                                                    },
                                                }}
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                            {selectedType === "windows" && (
                                <div style={{
                                    display: 'flex', flexDirection: 'column', gap: '10px', width: '22%',
                                    minHeight: '500px',

                                }}>
                                    <TextField
                                        label="Credential Name"
                                        required
                                        fullWidth
                                        sx={{ mt: 1.5 }}
                                        value={credentialName}
                                        onChange={(e) => setCredentialName(e.target.value)}
                                        onBlur={() => handleBlur("credentialName")}
                                        error={!!getError("credentialName", credentialName)}
                                        helperText={getError("credentialName", credentialName)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Description"
                                        fullWidth
                                        value={description} // Bind to state
                                        onChange={(e) => setDescription(e.target.value)} // Update state on change
                                        sx={{ mt: 1.5 }}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="User Name"
                                        required
                                        fullWidth
                                        value={username}
                                        sx={{ mt: 1.5 }}
                                        onChange={(e) => setUsername(e.target.value)}
                                        onBlur={() => handleBlur("username")}
                                        error={!!getError("username", username)}
                                        helperText={getError("username", username)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Password"
                                        required
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        fullWidth
                                        sx={{ mt: 1.5 }}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onBlur={() => handleBlur("password")}
                                        error={!!getError("password", password)}
                                        helperText={getError("password", password)}
                                        autoComplete="new-password"
                                        slotProps={{
                                            input: {
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <span className="visibility-icon">
                                                            {showPassword ? (
                                                                <Visibility
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                />
                                                            ) : (
                                                                <VisibilityOff
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                />
                                                            )}
                                                        </span>
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </div>
                            )}
                            {selectedType === "aws" && (
                                <Box sx={{ width: "22%" }}>
                                    <TextField
                                        label="Credential Name"
                                        required
                                        sx={{ mt: 2 }}
                                        fullWidth
                                        value={credentialName}
                                        onChange={(e) => setCredentialName(e.target.value)}
                                        onBlur={() => handleBlur("credentialName")}
                                        error={!!getError("credentialName", credentialName)}
                                        helperText={getError("credentialName", credentialName)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Description"
                                        fullWidth
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        autoComplete="off"
                                    />
                                    {/* <TextField
                                        label="Account ID"
                                        required
                                        fullWidth
                                        value={accountId}
                                        onChange={(e) => setAccountId(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        onBlur={() => handleBlur("accountId")}
                                        error={!!getError("accountId", accountId)}
                                        helperText={getError("accountId", accountId)}
                                        autoComplete="off"
                                    /> */}
                                    <TextField
                                        label="Access Key"
                                        required
                                        fullWidth
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        onBlur={() => handleBlur("username")}
                                        error={!!getError("username", username)}
                                        helperText={getError("username", username)}
                                        autoComplete="off"
                                    />
                                    <TextField
                                        label="Secret Key"
                                        required
                                        fullWidth
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        sx={{ mt: 2.5 }}
                                        onBlur={() => handleBlur("password")}
                                        error={!!getError("password", password)}
                                        helperText={getError("password", password)}
                                        autoComplete="new-password"
                                        slotProps={{
                                            input: {
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <span className="visibility-icon">
                                                            {showPassword ? (
                                                                <Visibility
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                />
                                                            ) : (
                                                                <VisibilityOff
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                />
                                                            )}
                                                        </span>
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </Box>
                            )}

                            <div>
                                <>
                                    {isLoadingCredentialTypes ? (
                                        <p>Loading credentialTypes...</p>
                                    ) : (
                                        <>
                                            {/* Credential Type Selection */}
                                            <div>
                                                <RadioGroup row value={selectedType} onChange={() => { }}>
                                                    {credentialTypes.map((item: any) => (
                                                        <FormControlLabel
                                                            key={item.code}
                                                            value={item.code}
                                                            control={<Radio />}
                                                            label={item.name}
                                                            onClick={() => handleRadioChange(item)} // Pass entire object here
                                                            sx={{
                                                                "& .MuiRadio-root.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </div>

                                            {/* Password Type Selection (Dynamic based on selectedType) */}
                                            {selectedType && (
                                                <div>
                                                    <p>Password Type</p>
                                                    <RadioGroup
                                                        row
                                                        value={passwordType || "none"}
                                                        sx={{ mt: 1 }}
                                                    >
                                                        {(
                                                            credentialTypes

                                                                .find((type: any) => type.code === selectedType)
                                                                ?.password_type || []
                                                        )
                                                            .filter((pt: any) => pt.code !== "none")
                                                            .map((pt: any) => (
                                                                <FormControlLabel
                                                                    key={pt.code}
                                                                    value={pt.code}
                                                                    control={<Radio />}
                                                                    label={pt.name}
                                                                    onClick={() => {
                                                                        //setPasswordType(pt.code); // Update selected code
                                                                        handlePasswordInputChange(pt); // Pass entire object here
                                                                    }}
                                                                    sx={{
                                                                        "& .MuiRadio-root.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />
                                                            ))}
                                                    </RadioGroup>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            </div>
                        </div>
                    </Box>
                </Card>
            )}

            {/* Cancel Confirmation Dialog - Unsaved Changes */}
            <Dialog
                sx={{
                    "& .MuiDialog-paper": {
                        width: "320px",
                        borderRadius: "12px",
                        padding: "8px",
                    },
                }}
                open={isCancelDialogOpen}
                onClose={handleCancelDialogClose}
            >
                <DialogTitle sx={{ padding: "16px 16px 8px 16px", textAlign: "center" }}>
                    <p style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }}>Unsaved Changes</p>
                    <p style={{ margin: "8px 0 0 0", fontSize: "13px", fontWeight: "normal", color: "#666" }}>
                        This action will cancel the Credential creation.
                    </p>
                </DialogTitle>
                <DialogActions
                    sx={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        padding: "8px 16px 16px 16px",
                    }}
                >
                    <Button
                        sx={{
                            width: "100px",
                            background: "#3A2ADA",
                            color: "white",
                            fontSize: "13px",
                            "&:hover": { background: "#2E22B0" }
                        }}
                        onClick={handleConfirmCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        sx={{ width: "100px", color: "#696595", borderColor: "#696595", fontSize: "13px" }}
                        variant="outlined"
                        onClick={handleCancelDialogClose}
                    >
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
};
export default AddCredentional;